require('./angular-css.js');
module.exports = 'angularCSS';



//////////////////
// WEBPACK FOOTER
// ./~/angular-css/index.js
// module id = 7
// module chunks = 1